import { createFileRoute, notFound } from "@tanstack/react-router";
import { EnvironmentDetail } from "../../features/training/environments";

export const Route = createFileRoute("/_authed/$org/$project/environments/$name")({
  validateSearch: (s: Record<string, unknown>) => ({ source: s.source === "catalog" ? "catalog" : undefined }),
  beforeLoad: ({ params }) => {
    // Environments are created from the SDK or CLI, so "new" names no console page.
    if (params.name === "new") throw notFound();
  },
  component: EnvironmentPage,
});

function EnvironmentPage() {
  const { org, project, name } = Route.useParams();
  const { source } = Route.useSearch();
  return <EnvironmentDetail scope={{ org, project }} name={name} source={source} />;
}
